import { getObjectValueByPath } from "@utils/helpers";

export default {
  props: {
    activeClass: String,
    append: Boolean,
    disabled: Boolean,
    exact: {
      type: Boolean,
      default: undefined
    },
    exactActiveClass: String,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    tag: String,
    target: String
  },

  data: () => ({
    isActive: false,
    proxyClass: ""
  }),

  computed: {
    classes() {
      const classes = {};

      if (this.to) return classes;

      if (this.activeClass) classes[this.activeClass] = this.isActive;
      if (this.proxyClass) classes[this.proxyClass] = this.isActive;

      return classes;
    },

    styles: () => ({})
  },

  methods: {
    click(e) {
      this.$emit("click", e);
    },

    generateRouteLink() {
      let exact = this.exact;
      let tag;

      const data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        style: this.styles,
        props: {},
        [this.to ? "nativeOn" : "on"]: {
          ...this.$listeners,
          click: this.click
        },
        ref: "link"
      };

      if (typeof this.exact === "undefined") {
        exact =
          this.to === "/" ||
          (this.to === Object(this.to) && this.to.path === "/");
      }

      if (this.to) {
        let activeClass = this.activeClass;
        let exactActiveClass = this.exactActiveClass || activeClass;

        if (this.proxyClass) {
          activeClass = `${activeClass} ${this.proxyClass}`.trim();
          exactActiveClass = `${exactActiveClass} ${this.proxyClass}`.trim();
        }

        tag = this.nuxt ? "nuxt-link" : "router-link";
        Object.assign(data.props, {
          to: this.to,
          exact,
          activeClass,
          exactActiveClass,
          append: this.append,
          replace: this.replace
        });
      } else {
        tag = (this.href && "a") || this.tag || "a";
        if (tag === "a" && this.href) data.attrs.href = this.href;
      }

      if (this.target) data.attrs.target = this.target;

      return { tag, data };
    },

    onRouteChange() {
      if (!this.to || !this.$refs.link || !this.$route) return;
      const activeClass = `${this.activeClass} ${this.proxyClass || ""}`.trim();

      const path = `_vnode.data.class.${activeClass}`;

      this.$nextTick(() => {
        if (getObjectValueByPath(this.$refs.link, path)) {
          this.toggle();
        }
      });
    },
    toggle: () => {}
  }
};
